import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import { gsap } from 'gsap'

import ScrollTrigger from 'gsap/ScrollTrigger'
import { down } from 'styled-breakpoints'
import image1 from '../../assets/images/mockup-1.png'
import image2 from '../../assets/images/mockup-2.png'
import image3 from '../../assets/images/mockup-3.png'
import image4 from '../../assets/images/mockup-4.png'
import image5 from '../../assets/images/Instagram-Icon.png'
// import useObserver from '../../hooks/useObserver'
import Stores from '../common/Stores'
import { DESKTOP_S, MOBILE, TABLET } from '../../lib/constant'
import useVariableSizeBox from '../../hooks/useVariableSizeBox'
import VariableSizeBox from '../common/VariableSizeBox'

export default function CTASection() {
	const sectionRef = useRef(null)

	useEffect(() => {
		if (!sectionRef.current) {
			return
		}
		const timeline = gsap.timeline({
			scrollTrigger: {
				trigger: sectionRef.current,
				toggleActions: 'play pause restart reset',
				start: 'top bottom',
			},
		})

		timeline.fromTo(
			'.mockup-image',
			{
				y: 0,
			},
			{
				delay: (index) => index * 0.025,
				y: -650,
				autoAlpha: 1,
				ease: 'Power3.easeOut',
			},
			'+=0.3'
		)

		ScrollTrigger.matchMedia({
			// DESKTOP_L
			'(min-width: 1440px)': () => {
				ScrollTrigger.refresh()
			},
			// DESKTOP_S
			'(max-width: 1439px) and (min-width: 1024px)': () => {
				ScrollTrigger.refresh()
			},
			// TABLET
			'(max-width: 1023px) and (min-width: 768px)': () => {
				ScrollTrigger.refresh()
			},
			// MOBILE
			'(max-width: 767px)': () => {
				ScrollTrigger.refresh()
			},
		})

		return () => {
			timeline.kill()
		}
	}, [])

	const width = useVariableSizeBox(560, {
		tablet: (vw) => vw - 16,
	})

	return (
		<Section ref={sectionRef}>
			<ResponsiveWrapper>
				<VariableSizeBox
					defaultHeight={560}
					defaultWidth={560}
					width={width}
					ref={sectionRef}
				>
					<Images>
						<RotatedImages>
							<ImageColumn className="mockup-image">
								<img src={image1} alt="iphone" />
							</ImageColumn>
							<ImageColumn className="mockup-image">
								<img src={image4} alt="iphone" />
								<img src={image3} alt="iphone" style={{ marginTop: 32 }} />
							</ImageColumn>
							<ImageColumn className="mockup-image">
								<img src={image2} alt="iphone" />
							</ImageColumn>
						</RotatedImages>
					</Images>
				</VariableSizeBox>
				<Content>
					<ContentText>
						타고가와 함께 <br /> 바로 도심속 라이딩을 <br /> 즐겨보세요.
					</ContentText>
					<Stores className="stores" />
				</Content>
				
			</ResponsiveWrapper>
		</Section>
	)
}

const Section = styled.section`
	width: 100%;
	background-color: #fafafa;
	overflow: hidden;
	padding: 0 16px;
	height: 560px;
	margin-top: 80px;
	${down(TABLET)} {
		height: 680px;
	}
	${down(MOBILE)} {
		height: 480px;
	}
`

const ResponsiveWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 1080px;
	width: 100%;
	margin: 0 auto;
	position: relative;

	${down(TABLET)} {
		flex-direction: column-reverse;
		align-items: flex-start;
	}
`

const Images = styled.div`
	transform: translateX(-200px);
	${down(TABLET)} {
		transform: translateX(0);
		margin-right: 0;
		margin-top: 40px;
	}
`

const RotatedImages = styled.div`
	display: flex;
	align-items: center;
	transform: rotate(-30deg) translate(0, 80%);

	${down(TABLET)} {
		transform: rotate(-30deg) translate(0, 125%);
	}
`

const ImageColumn = styled.div`
	width: 235px;
	margin: 0 12px;

	img {
		width: 100%;
	}
	${down(DESKTOP_S)} {
		width: 200px;
		margin: 0 12px;
	}
	${down(TABLET)} {
		width: 100px;
		margin: 0 8px;
	}
`

const Content = styled.div`
	margin-top: 156px;
	margin-bottom: 156px;
	z-index: 1;
	margin-left: auto;
	max-width: 680px;
	width: 100%;
	.stores {
		margin-top: 32px;
	}

	${down(TABLET)} {
		margin-left: 0;
		max-width: 100%;
		position: relative;
		margin-top: 32px;
		margin-bottom: 0;

		.stores {
			margin-top: 16px;
		}
	}
`

const ContentText = styled.h3`
	font-size: 56px;
	line-height: 64px;
	font-weight: 700;

	${down(TABLET)} {
		font-size: 32px;
		line-height: 40px;
	}
`
